const footerNav = [
  { title: "栏目导航", links: [
    { label: "实时现场", href: "#feed" },
    { label: "反转档案", href: "#timeline" },
    { label: "为何可信", href: "#why" },
    { label: "常见问题", href: "#faq" },
    { label: "订阅追瓜", href: "#subscribe" },
  ] },
  { title: "追瓜分类", links: [
    { label: "明星娱乐", href: "#feed" },
    { label: "直播圈", href: "#feed" },
    { label: "品牌公关", href: "#feed" },
    { label: "社会热点", href: "#feed" },
    { label: "体育电竞", href: "#feed" },
  ] },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                爆炸<span className="text-primary-600">瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注热点事件发酵追踪的媒体站点，持续更新事件后续进展，复盘反转再反转的完整脉络，帮你理清每一个吃瓜现场。
            </p>
          </div>

          {footerNav.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} onClick={(e) => { e.preventDefault(); document.querySelector(l.href)?.scrollIntoView({ behavior: "smooth" }); }} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">联系与投稿</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                <a href="mailto:gossip@baozhagua.example.com" className="hover:text-primary-700">
                  gossip@baozhagua.example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-600" />
                编辑部 9:00 - 22:00 在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 爆炸瓜 · 所有内容基于公开信息整理，以官方为准</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-secondary-600" />
            保持客观 · 尊重事实 · 持续更新
          </p>
        </div>
      </div>
    </footer>
  );
}